export enum GisUploadOption {
  Any = 'Any',
  AdvancedOnly = 'Advanced',
}
